"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstructorModel = void 0;
const baseSlug_model_abstract_1 = require("../baseSlug.model.abstract");
const sessionlight_model_1 = require("../session/sessionlight.model");
class InstructorModel extends baseSlug_model_abstract_1.BaseSlugModelAbstract {
    constructor(obj = null, deepClone = false) {
        super("InstructorModel");
        this.idInstructor = 0;
        this.name = "";
        this.surname = "";
        this.slug = "";
        this.jobTitle = null;
        this.company = null;
        this.description = null;
        this.deleted = true;
        this.updatedAt = null;
        this.imageUrl = null;
        this.sessionInstructor = [];
        this.typology = null;
        this.categories = null;
        if (obj != null) {
            this.clone(obj, deepClone);
        }
    }
    clone(obj, deep = false) {
        this.idInstructor = obj.idInstructor;
        this.name = obj.name;
        this.surname = obj.surname;
        this.imageUrl = obj.imageUrl;
        this.slug = obj.slug;
        this.jobTitle = obj.jobTitle;
        this.company = obj.company;
        this.description = obj.description;
        this.deleted = obj.deleted;
        this.updatedAt = obj.updatedAt;
        this.typology = obj.typology;
        this.categories = obj.categories;
        if (deep) {
            obj.sessionInstructor.forEach(v => this.sessionInstructor.push(new sessionlight_model_1.SessionLightModel(v, false)));
        }
        else {
            this.sessionInstructor = obj.sessionInstructor;
        }
    }
    isEmpty() {
        return this.idInstructor == 0;
    }
    static fromJSON(d) {
        const model = Object.assign(new InstructorModel(), typeof d === 'string' ? JSON.parse(d) : d);
        return new InstructorModel(model);
    }
}
exports.InstructorModel = InstructorModel;
//# sourceMappingURL=instructor.model.js.map